<template>
    <div class="content-us">
      <el-col :span="24" :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="content-box">
        <el-row class="p-t16" style="text-align: left;  ">
            <el-col :span="8" :xs="5" style="   padding: 8px;">
              </el-col>
            <el-col :span="16" :xs="19"  style="    text-align: left;    padding: 8px;">
              <h3>深圳市微影医疗科技有限公司<br></h3>
            </el-col>
        </el-row>
        <el-row style="text-align: left; ">
            <el-col :span="8" :xs="6" style="    text-align: right;    padding: 8px;    display: flex;    flex-direction: column;">
              <b>深圳总部:</b>
            </el-col>
            <el-col :span="16" :xs="18"  style="    text-align: left;    padding: 8px;">
                <span>深圳市南山区学苑大道1001号南山智园C2栋18楼<br></span>
            </el-col>
        </el-row>
        <el-row style="text-align: left; ">
            <el-col :span="8" :xs="6" style="    text-align: right;    padding: 8px;    display: flex;    flex-direction: column;">
              <!-- <b>电话:</b> -->
            </el-col>
            <el-col :span="16" :xs="18"  style="    text-align: left;    padding: 8px;">
                <!-- <span>0755- <br></span> -->
            </el-col>
        </el-row>
        <el-row class="p-t16" style="text-align: left;   ">
            <el-col :span="8" :xs="6" style="    text-align: right;    padding: 8px;    display: flex;    flex-direction: column;">
              <b>南昌研发中心:</b>
            </el-col>
            <el-col :span="16" :xs="18"  style="    text-align: left;    padding: 8px;">
                <span>江西省南昌市高新开发区火炬大街161号嘉德商业广场海上汇703室<br></span>
            </el-col>
        </el-row>
        <el-row style="text-align: left;   ">
            <el-col :span="8" :xs="6" style="    text-align: right;    padding: 8px;    display: flex;    flex-direction: column;">
              <!-- <b>电话:</b> -->
            </el-col>
            <el-col :span="16" :xs="18"  style="    text-align: left;    padding: 8px;">
                <!-- <span>0755- <br></span> -->
            </el-col>
        </el-row>
      </el-col>
    </div>
</template>
<script>
export default {
  name: "contentUs",
  data() {
    return {
    };  
  },
  mounted() {
  },
  methods: {
  },
  components: {
  }
};
</script>
<style>
.content-us {
    background: var(--WhiteColor-1);
    height: 100%;
    margin-top: 8px;
    font-size: 14px;
    justify-content: center;
    display: flex;
}
.content-us .content-box {
    /* width: 100%; */
    height: 100%;
  color: var(--BlackColor-1);
  overflow: auto;
}
.content-us .pro-item-box {
  /* background: var(--PrimaryColor-30); */
  color: var(--WhiteColor-1);
}

</style>